import React from 'react';
import $ from 'jquery';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

import fetchJSON from '@api/api_helper';
import Tooltip from '@components/common/tooltip/main';
import getAssetInfo from '@api/v4/private/brandfolders/bulkAssetsInfo';
import download from '@helpers/download';
import { postCsvPoller as csvFetch } from '@api/v4/assets/csv_metasheets';

import { Collection } from '@helpers/show_page_helpers';
import BulkAction from './BulkActionComponent';
import BulkAvailabilityModal from './BulkAvailabilityModal';
import BulkCollectionModal from './BulkCollectionModal';
import BulkRemoveLabelModal from './BulkRemoveLabelModal';
import BulkAddLabelModal from './BulkAddLabelModal';
import BulkDeleteModal from './BulkDeleteModal';
import BulkMergeModal from './BulkMergeModal';
import BulkMoveModal from './BulkMoveModal';
import BulkShareModal from './BulkShareModal';
import BulkShareLinkModal from './BulkShareLinkModal';
import BulkTagWrapper from './BulkTagWrapper';
import BulkBoardModal from './BulkBoardModal';
import RequestDownloadAccessModal from './RequestDownloadAccessModal';
import DownloadAccessResponse from './DownloadAccessResponse';

import './styles/bulk_select_bar.scss';

class BulkSelectBar extends React.Component {
  state = {
    activeCdnTracers: null,
    disableDownloadClick: false,
    expandedAddTo: false,
    hasSubCollections: false,
    mobileMenuExpanded: false,
    showModal: null,
    selectedAssetsData: [],
    selectedAssetTypes: new Set(),
    selectedAssetsApproved: false,
  };

  componentDidMount() {
    if ($('body').hasClass('desktop-view') || $('body').hasClass('desktop-narrow-view')) {
      this.determineBrowserWidth(); // execute on page load
      window.addEventListener('resize', this.determineBrowserWidth);
    }
    this.determineSubCollectionsPresent();
  }

  componentDidUpdate(prevProps) {
    const assetsProcessingDone = this.props.assetsProcessing < prevProps.assetsProcessing;
    const selectedAssetKeysDifferent = this.props.selectedAssetKeys.size !== prevProps.selectedAssetKeys.size;
    if ((assetsProcessingDone || selectedAssetKeysDifferent) && this.props.selectedAssetKeys.size) {
      // comparing previous and current props.selectedAssetKeys.size did not behave as expected
      // componentDidUpdate did not catch a difference in previous and current
      // props.selectedAssetKeys.size on asset upload
      // so using props.assetsProcessing here to trigger this
      this.getSelectedAssetsData();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.determineBrowserWidth);
  }

  getCurrentCollection = async () => (
    fetchJSON(`/api/v4/collections/${BFG.resource.key}?include=subcollections`));

  // subCollections will indicate that the Add to [Sub]Collections option should be available
  // when a Collection is the resource
  determineSubCollectionsPresent = () => {
    if (BFG?.resource?.type !== "collection") { return; }
    this.getCurrentCollection().then((response) => {
      const subCollectionsPresent = !!response?.included?.find((includedObject) => includedObject?.type === "collections");
      if (subCollectionsPresent) {
        this.setState({ hasSubCollections: true });
      }
    });
  }

  getSelectedAssetsData = () => {
    if (this.props.orgSearchPage) { return undefined; }

    const { selectedAssetKeys } = this.props;
    if (selectedAssetKeys.size > 0) {
      getAssetInfo({
        brandfolderKey: BF.fx.brandfolder().key,
        assetKeys: Array.from(selectedAssetKeys),
      }).then(({ types, assets, approved, active_cdn_tracers }) => {
        this.setState({
          selectedAssetTypes: new Set(types),
          activeCdnTracers: active_cdn_tracers,
          selectedAssetsData: assets,
          selectedAssetsApproved: approved
        });
      });
    } else {
      this.setState({
        selectedAssetsData: [],
        selectedAssetTypes: new Set(),
        selectedAssetsApproved: false,
      });
    }
    return undefined;
  }

  resetShowModal = () => {
    this.setState({ showModal: null });
  }

  determineBrowserWidth = () => {
    const $windowWidth = $(window).width();
    const $body = $('body');

    if ($windowWidth <= 935 && $body.hasClass('desktop-view')) {
      $body.removeClass('desktop-view').addClass('desktop-narrow-view');
    } else if ($windowWidth > 935 && $body.hasClass('desktop-narrow-view')) {
      $body.removeClass('desktop-narrow-view').addClass('desktop-view');
    }
  }

  closeBulkSelectBar = () => {
    this.setState({ mobileMenuExpanded: false });
    this.props.addRemoveSelected([]);
  }

  renderModal = () => {
    const {
      activeLabelKey,
      addRemoveSelected,
      labels,
      selectedAssetKeys,
      libraryName,
      requestDownloadName,
      requestDownloadRequestee,
      ugtLocale,
    } = this.props;
    const {
      selectedAssetsData,
      selectedAssetTypes,
      showModal
    } = this.state;

    switch (showModal) {
      case "BulkShareModal":
        return (
          <BulkShareModal
            closeModal={this.resetShowModal}
            selectedAssetKeys={selectedAssetKeys}
          />
        );
      case "BulkShareLinkModal":
        return (
          <BulkShareLinkModal
            closeModal={this.resetShowModal}
            selectedAssetKeys={selectedAssetKeys}
          />
        );
      case "BulkTagWrapper":
        return (
          <BulkTagWrapper
            closeModal={this.resetShowModal}
            selectedAssetKeys={selectedAssetKeys}
            ugtLocale={ugtLocale}
          />
        );
      case "BulkCollectionModal":
        return (
          <BulkCollectionModal
            closeModal={this.resetShowModal}
            selectedAssetKeys={selectedAssetKeys}
          />
        );
      case "BulkAvailabilityModal":
        return (
          <BulkAvailabilityModal
            activeCdnTracers={this.state.activeCdnTracers}
            closeModal={this.resetShowModal}
            selectedAssetKeys={selectedAssetKeys}
          />
        );
      case "BulkRemoveLabelModal":
        return (
          <BulkRemoveLabelModal
            activeLabelKey={activeLabelKey}
            addRemoveSelected={addRemoveSelected}
            closeModal={this.resetShowModal}
            labels={labels}
            selectedAssetKeys={selectedAssetKeys}
          />
        );
      case "BulkAddLabelModal":
        return (
          <BulkAddLabelModal
            activeLabelKey={activeLabelKey}
            addRemoveSelected={addRemoveSelected}
            closeModal={this.resetShowModal}
            labelTree={labels.labelsTree}
            selectedAssetKeys={selectedAssetKeys}
          />
        );
      case "BulkDeleteModal":
        return (
          <BulkDeleteModal
            addRemoveSelected={addRemoveSelected}
            closeModal={this.resetShowModal}
            selectedAssetKeys={selectedAssetKeys}
          />
        );
      case "BulkBoardModal":
        return (
          <BulkBoardModal
            closeModal={this.resetShowModal}
            selectedAssetKeys={selectedAssetKeys}
          />
        );
      case "BulkMergeModal":
        return (
          <BulkMergeModal
            addRemoveSelected={addRemoveSelected}
            closeModal={this.resetShowModal}
            selectedAssetKeys={selectedAssetKeys}
            selectedAssetsData={selectedAssetsData}
          />
        );
      case "BulkMoveModal":
        return (
          <BulkMoveModal
            addRemoveSelected={addRemoveSelected}
            closeModal={this.resetShowModal}
            libraryName={libraryName}
            selectedAssetKeys={selectedAssetKeys}
            selectedAssetTypes={selectedAssetTypes}
          />
        );
      case "RequestDownloadAccess":
        return (
          <RequestDownloadAccessModal
            closeModal={this.resetShowModal}
            selectedAssetKeys={selectedAssetKeys}
          />
        );
      case "DownloadAccessResponse":
        return (
          <DownloadAccessResponse
            closeModal={this.resetShowModal}
            requestDownloadName={requestDownloadName}
            requestDownloadRequestee={requestDownloadRequestee}
            selectedAssetKeys={selectedAssetKeys}
          />
        );
      default:
        return <div />;
    }
  }

  bulkAction = (modalName, icon, copy, withText = false) => (
    <Tooltip
      className={`${copy.split(' ').join('-')}-tooltip-component`}
      offset={`{'top': -20}`}
      tooltipContent={copy}
      tooltipId={`${copy.split(' ').join('-')}-tooltip`}
      type="light"
    >
      <div
        className={`bulk-bar-item hover-item ${withText ? 'with-text' : ''}`}
        onClick={() => this.setState({ showModal: `${modalName}` })}
      >
        <span
          aria-hidden={withText}
          aria-label={withText ? '' : `${copy}`}
          className={`icon ${icon}`}
        />
        <h4 className="action-text">{copy}</h4>
      </div>
    </Tooltip>
  );

  bulkActionDownload = () => {
    const { disableDownloadClick } = this.state;
    const disabledClass = disableDownloadClick ? 'disabled-section' : '';

    return (
      <div
        className={`bulk-bar-item with-text download-action hover-item ${disabledClass} action-text`}
        onClick={() => this.bulkDownloadAlert(this.bulkDownloadAssets)}
      >
        <span aria-hidden="true" className="icon bff-download" />
        <h4 className="download-text action-text">{bfTranslate('Download')}</h4>
        {!this.props.orgSearchPage && ( // TODO implement "download some" for org search page
          <div className="hide-touchscreen">
            <div className="download-options-container">
              <div
                className="download-container hover-item"
                onClick={(e) => {
                  e.stopPropagation();
                  BF.BulkAction.bulk_advanced_download_show(this);
                }}
              >
                <h4 className="download-actions">{bfTranslate('Download Some')}</h4>
              </div>
              <div
                className={`download-container hover-item ${disabledClass}`}
                onClick={(e) => {
                  e.stopPropagation();
                  this.bulkDownloadAlert(this.bulkDownloadAssets);
                }}
              >
                <h4 className="download-actions">{bfTranslate('Download All')}</h4>
              </div>
              { (BFG.context.hasFeature('csv_metasheets') && ['collaborator', 'admin', 'owner'].indexOf(BFG.currentUser.role) > -1) && (
                <div
                  className={`download-container hover-item ${disabledClass}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.bulkDownloadAlert(this.bulkCSVDownloadAssets);
                  }}
                >
                  <h4 className="download-actions">{bfTranslate('Download CSV')}</h4>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }

  csvPoller = (downloadKey, resourceType, resourceKey, counter) => {
    const slug = BF.fx.resource().slug || 'share_manifest';
    const options = { slug, downloadKey, resourceType, resourceKey, params: { manifest_digest: BFG.manifestDigest } };
    const resourceName = BF.fx.resource().name;
    const $downloadIndicator = $('.download_progress_indicator');

    csvFetch(options)
      .then(({ response, json }) => {
        if (response.status === 200) {
          this.setState({ disableDownloadClick: false });
          download(json.download_url, { filename: `${resourceName}-assets.csv`, filetype: 'text/csv' });

          setTimeout(() => {
            $downloadIndicator.css('visibility', 'hidden').removeClass('active bulk-download');
          }, 1000);

          Notify.create({
            title: `${bfTranslate('Downloaded')}`,
            type: "success"
          });
        } else if (response.status === 202 && counter < 600) {
          // set to expire at 10 minutes (600 x 1000 = 600,0000 = 10 minutes)
          setTimeout(() => { this.csvPoller(options.downloadKey, options.resourceType, options.resourceKey, counter + 1); }, 1000);
        } else {
          Notify.create({
            title: bfTranslate('Something went wrong. Try again soon!'),
            type: 'error'
          });
        }
      })
      .catch((error) => {
        Notify.create({
          title: bfTranslate('Something went wrong. Try again soon!'),
          type: 'error'
        });
        console.log(error);
      });
  };

  bulkCSVDownloadAssets = () => {
    this.setState({ disableDownloadClick: true });

    const $downloadIndicator = $('.download_progress_indicator');

    $downloadIndicator.addClass('active bulk-download').css('visibility', 'visible');

    const slug = BF.fx.resource().slug || 'share_manifest';
    const { ugtLocale } = this.props;
    const ugtLocaleParam = ugtLocale ? `?ugt_locale=${ugtLocale}&queue_priority=high` : '?queue_priority=high';

    const url = `/${slug}/assets/csv/download_assets${ugtLocaleParam}`;
    const resourceType = BF.fx.resource().type;
    const resourceKey = BF.fx.resource().key;

    $.ajax({
      url,
      type: 'POST',
      data: {
        asset_keys: Array.from(this.props.selectedAssetKeys),
        resource_type: resourceType,
        resource_key: resourceKey,
      },
      context: this,
      beforeSend: (xhr) => {
        xhr.setRequestHeader('Authorization', `Bearer ${BF_Token}`);
      },
      success: (response, message, http) => {
        if (http.status === 202) {
          this.csvPoller(response.download_key, response.resource_type, response.resource_key, 0);
        } else {
          $downloadIndicator.css('visibility', 'hidden').removeClass('active bulk-download');
        }
      },
      error: () => {
        this.setState({ disableDownloadClick: false });
        Notify.create({
          title: bfTranslate('Something went wrong. Try again soon!'),
          type: 'error'
        });
        $downloadIndicator.css('visibility', 'hidden').removeClass('active bulk-download');
      }
    });
  };

  bulkDownloadAssets = () => {
    this.setState({ disableDownloadClick: true });

    const { selectedAssetKeys } = this.props;
    const $downloadIndicator = $('.download_progress_indicator');

    // overriding default translation to get above bulk select bar by adding class 'bulk-download'
    $downloadIndicator.addClass('active bulk-download').css('visibility', 'visible');

    const url = BF_Manifest
      ? `/api/v3/share_manifests/${BF_Manifest}/assets/download?queue_priority=high`
      : "/api/v3/assets/download?queue_priority=high";

    $.ajax({
      url,
      type: 'POST',
      data: { asset_keys: Array.from(selectedAssetKeys) },
      context: this,
      beforeSend: (xhr) => { xhr.setRequestHeader('Authorization', `Bearer ${BF_Token}`); },
      success: (response) => {
        this.setState({ disableDownloadClick: false });
        if (response.data && !!response.data.redirect_url) {
          window.location.href = response.data.redirect_url;
          setTimeout(() => {
            $downloadIndicator.css('visibility', 'hidden').removeClass('active bulk-download');
          }, 1000);
          const fileCount = parseInt(response.data.attachment_count || response.data.total_count, 10);
          const fileCopy = fileCount === 1 ? bfTranslate('asset') : bfTranslate('assets');
          Notify.create({
            title: `${bfTranslate('Downloaded')} ${fileCount} ${fileCopy}`,
            type: "success"
          });
        } else {
          BF.BulkAction.result_poller(url.replace('download', 'bulk-convert-download-poller'), response.data, 500);
        }
      },
      error: () => {
        this.setState({ disableDownloadClick: false });
        Notify.create({
          title: bfTranslate('Something went wrong. Try again soon!'),
          type: 'error'
        });
        $downloadIndicator.css('visibility', 'hidden').removeClass('active bulk-download');
      },
      complete: () => {
        // Create asset download events
        selectedAssetKeys.forEach((assetKey) => {
          Insight.createEvent('downloaded', assetKey, 'asset');
        });
      }
    });
  }

  bulkDownloadAlert = (downloadCallback) => {
    if (BFG.downloadAlertEnabled) {
      BF.fx.dispatchWindowEvent('launchDownloadAlert', null, {
        downloadCallback
      });
    } else {
      downloadCallback();
    }
  }

  bulkActionComponent(actionType) {
    const { selectedAssetKeys, approver, addRemoveSelected } = this.props;
    const { activeCdnTracers, selectedAssetsApproved } = this.state;

    return (
      <BulkAction
        actionType={actionType}
        activeCdnTracers={activeCdnTracers}
        addRemoveSelected={addRemoveSelected}
        approver={approver}
        assetsApproved={selectedAssetsApproved}
        resetShowModal={this.resetShowModal}
        selectedAssetKeys={selectedAssetKeys}
      />
    );
  }

  bulkActionAddMobile(actions) {
    const { expandedAddTo } = this.state;

    return (
      <CSSTransition
        in={expandedAddTo}
        timeout={300}
        unmountOnExit
      >
        <ul className="show-touchscreen add-to-options">
          {
            actions.map((action) => {
              const cssClassName = action.name.split(' ').join('-');
              return (
                <li
                  key={`flyout-button-mobile-${cssClassName}`}
                  className="add-to-item"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.setState({ showModal: action.modal });
                  }}
                >
                  {bfTranslate(action.name)}
                </li>
              );
            })
          }
        </ul>
      </CSSTransition>
    );
  }

  bulkActionAddDesktop(actions) {
    return (
      <div className="hide-touchscreen">
        <div className="download-options-container">
          {
            actions.map((action) => {
              const cssClassName = action.name.split(' ').join('-');
              return (
                <div
                  key={`flyout-button-${cssClassName}`}
                  className={`download-container hover-item add-to-${cssClassName}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.setState({ showModal: action.modal });
                  }}
                >
                  <h4 className="download-actions">{bfTranslate(`Add to ${action.name}`)}</h4>
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }

  // TODO
  // Make this, and possibly all the other buk actions a seperate component
  bulkActionFlyout(actions) {
    const { expandedAddTo } = this.state;
    return (
      <>
        <div
          className="bulk-bar-item with-text download-action add-to hover-item action-text"
          onClick={() => this.setState({ expandedAddTo: !expandedAddTo })}
        >
          <span aria-hidden="true" className="icon bff-plus" />
          <h4 className="download-text action-text">{bfTranslate('Add to')}</h4>
          <div className="show-touchscreen">
            {
              expandedAddTo ? (
                <span aria-hidden="true" className="icon bff-caret-up" />
              ) : (
                <span aria-hidden="true" className="icon bff-caret-down" />
              )
            }
          </div>
          { this.bulkActionAddDesktop(actions) }
        </div>
        { this.bulkActionAddMobile(actions) }
      </>
    );
  }

  // determine if we need a flyout of options or just one button for 'Add To'
  addToActionsRuleset() {
    const { editable } = this.props;

    // showPageLite = share manifests/links
    // TODO: If we add more than a handful of these
    // we are gonna need something more sophisticated
    const showNone = BFG.showPageLite || !BFG.currentUser.user_id;
    const allowCollections = !showNone && editable && (!Collection.key || this.state.hasSubCollections);
    const allowBoards = !showNone;
    const allowLabels = !showNone && editable && BFG.hasFeature('labels');
    const allowShareLinks = !showNone && editable && BFG.hasFeature('rollout_share_link_enhancements');

    const Boards = {
      name: bfTranslate('Boards'),
      icon: 'bff-boards',
      modal: 'BulkBoardModal'
    };

    const Collections = {
      name: this.state.hasSubCollections ? bfTranslate('Subcollections') : bfTranslate('Collections'),
      icon: 'bff-plus',
      modal: 'BulkCollectionModal'
    };

    const Labels = {
      name: bfTranslate('Labels'),
      icon: 'bff-label',
      modal: 'BulkAddLabelModal'
    };

    const ShareLink = {
      name: bfTranslate('Share Link'),
      icon: 'bff-share',
      modal: 'BulkShareLinkModal'
    };

    const actions = [];

    // share manifest page etc get NOTHING
    if (showNone) {
      return [];
    }
    if (allowCollections) {
      actions.push(Collections);
    }
    if (allowBoards) {
      actions.push(Boards);
    }
    if (allowLabels) {
      actions.push(Labels);
    }
    if (allowShareLinks) {
      actions.push(ShareLink);
    }
    return actions;
  }

  renderBulkSelectActions() {
    const {
      allVisibleAssetKeys,
      selectAllVisible,
      selectedAssetKeys,
    } = this.props;

    const visibleAssetKeysSelected = allVisibleAssetKeys.filter((assetKey) => (selectedAssetKeys.has(assetKey)));
    const allClass = visibleAssetKeysSelected.length === allVisibleAssetKeys.length
      ? 'all-selected'
      : '';

    return (
      <div className="select-actions-container">
        <div className="bulk-bar-item select-qty">
          <h4 className="select-text-faded">{`${selectedAssetKeys.size} `} {bfTranslate('selected')}</h4>
        </div>
        <div className="bulk-bar-item select-title">
          <h4 className="select-text-faded">{bfTranslate('Select')}:</h4>
        </div>
        <div
          className={`bulk-bar-item hover-item select-all ${allClass}`}
          onClick={() => selectAllVisible()}
        >
          <h4 className="select-text">{bfTranslate('All Visible')}</h4>
        </div>
        <div
          className="bulk-bar-item hover-item select-none"
          onClick={() => this.closeBulkSelectBar()}
        >
          <h4 className="select-text">{bfTranslate('None')}</h4>
        </div>
      </div>
    );
  }

  renderBulkActionToolbar() {
    const { activeLabelKey, approver, displayDownload, editable, selectedAssetKeys } = this.props;
    const { selectedAssetTypes } = this.state;
    const onlyGenericFiles = selectedAssetTypes.size === 1 && selectedAssetTypes.has('GenericFile');
    const mobileClassMenu = this.state.mobileMenuExpanded ? 'mobile-expanded' : '';
    const mobileMenuPromptClass = this.state.mobileMenuExpanded ? 'mobile-prompt-hidden' : '';
    const addToActions = this.addToActionsRuleset();
    /* eslint-disable no-nested-ternary, no-undef */
    return (
      <div className={`bulk-actions-bar active ${mobileClassMenu}`}>
        <div className={`mobile-expand-prompt hide-desktop ${mobileMenuPromptClass}`}>
          { this.renderBulkSelectActions() }
          <div
            className="view-bulk-select-bar hover-item"
            onClick={() => this.setState((prevState) => ({ mobileMenuExpanded: !prevState.mobileMenuExpanded }))}
          >
            <span className="bff-ellipsis icon" />
            <h4 className="action-text">{bfTranslate('More Actions')}</h4>
          </div>
        </div>

        { this.renderBulkSelectActions() }
        <div className="bulk-actions-container">
          {(editable && approver && BFG.context.hasFeature('asset_approvals')) ? this.bulkActionComponent('BulkApproval') : null}
          {(editable && !Collection.key && BFG.context.hasFeature('asset_availability')) ? this.bulkAction('BulkAvailabilityModal', 'bff-clock', bfTranslate('Schedule Availability')) : null}
          {(editable && !Collection.key && selectedAssetTypes.size === 1) ? this.bulkAction('BulkMoveModal', 'bff-move', bfTranslate('Move')) : null}
          {(editable && !Collection.key && activeLabelKey) ? this.bulkAction('BulkRemoveLabelModal', 'bff-label', bfTranslate('Remove Label')) : null}
          {(editable && !Collection.key) ? this.bulkAction('BulkDeleteModal', 'bff-trash', bfTranslate('Delete')) : null}
          {(editable) ? this.bulkAction('BulkTagWrapper', 'bff-tag', bfTranslate('Tag'), true) : null }
          {(editable && selectedAssetKeys.size > 1 && selectedAssetKeys.size < 50 && onlyGenericFiles) ? this.bulkAction('BulkMergeModal', 'bff-merge', bfTranslate('Merge'), true) : null}
          {addToActions.length > 1 ? this.bulkActionFlyout(addToActions) : null}
          {addToActions.length === 1 ? this.bulkAction(addToActions[0].modal, addToActions[0].icon, addToActions[0].name, true) : null}
          {(editable && Collection.key) ? this.bulkActionComponent('BulkCollectionRemoval') : null}
          {(BFG.context.hasFeature('share_links') && !BFG.showPageLite && (editable || !BFG.viewOnly)) ? this.bulkAction('BulkShareModal', 'bff-share', bfTranslate('Share'), true) : null}
          {BFG.viewOnly && this.bulkAction('RequestDownloadAccess', 'bff-request-download', bfTranslate('Prepare Request'), true)}
          {BFG.downloadRequestKey && this.bulkAction('DownloadAccessResponse', 'bff-approve', bfTranslate('Approve Selected Assets'), true)}
          {(editable || !BFG.viewOnly) && !BFG.downloadRequestKey && displayDownload && this.bulkActionDownload()}
        </div>
        <div
          className="close-container hover-item hide-touchscreen"
          onClick={() => this.closeBulkSelectBar()}
        >
          <span className="bff-close icon" />
          <h4 className="hide-desktop close-text">{bfTranslate('Deselect All & Close')}</h4>
        </div>
        <div
          className="close-container hover-item hide-desktop"
          onClick={() => this.setState((prevState) => ({ mobileMenuExpanded: !prevState.mobileMenuExpanded }))}
        >
          <h4 className="hide-desktop close-text">{bfTranslate('Hide')}</h4>
        </div>
      </div>
    );
    /* eslint-enable no-nested-ternary, no-undef */
  }

  render() {
    return (
      <div>
        {this.renderModal()}
        {this.props.selectedAssetKeys.size > 0
          ? this.renderBulkActionToolbar()
          : <div className="bulk-actions-bar" />}
      </div>
    );
  }
}

BulkSelectBar.propTypes = {
  activeLabelKey: PropTypes.string,
  addRemoveSelected: PropTypes.func.isRequired,
  allVisibleAssetKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  approver: PropTypes.bool.isRequired,
  assetsProcessing: PropTypes.number,
  displayDownload: PropTypes.bool,
  editable: PropTypes.bool.isRequired,
  labels: PropTypes.shape({}),
  libraryName: PropTypes.string,
  orgSearchPage: PropTypes.bool,
  requestDownloadName: PropTypes.string,
  requestDownloadRequestee: PropTypes.string,
  selectAllVisible: PropTypes.func.isRequired,
  selectedAssetKeys: PropTypes.instanceOf(Set).isRequired,
  ugtLocale: PropTypes.string,
};

BulkSelectBar.defaultProps = {
  activeLabelKey: null,
  assetsProcessing: 0,
  displayDownload: true,
  labels: {},
  libraryName: "Brandfolder",
  orgSearchPage: false,
  requestDownloadName: '',
  requestDownloadRequestee: '',
  ugtLocale: '',
};

export default BulkSelectBar;
